import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import { ClassValue } from 'classnames/types';
import { withLoading, WithLoadingProps } from '@adjust/dashboard-components';

export interface TileWithLoadingProps {
  extraClasses?: ClassValue;
}

/**
 * Wraps the passed component with the tile loader functionality
 *
 * @param {Component} wrapped
 * @returns {Component}
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function TileWithLoading<T>(wrapped: React.ComponentType<T>) {
  const WrappedWithLoading = withLoading(wrapped);

  const wrappedWithTileWithLoading: React.FC<TileWithLoadingProps & WithLoadingProps & T> = ({
    extraClasses,
    ...otherProps
  }) => {
    const classes = classNames('your-data-card', extraClasses);

    return (
      <div className={classes}>
        <WrappedWithLoading {...(otherProps as T & WithLoadingProps)} />
      </div>
    );
  };

  return wrappedWithTileWithLoading;
}

export const tileWithLoadingPropTypes = {
  isLoading: PropTypes.bool.isRequired,
  extraClasses: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
